import React from 'react';
import { Button, Tooltip } from '@fluentui/react-components';
import { getFileIcon } from '../../icons/DocumentIcon'


interface FileDownloadListItemProps {
    fileName: string;
    onDownload: () => void;
}

export const FileDownloadListItem: React.FC<FileDownloadListItemProps> = ({ fileName, onDownload }) => {
    // Dosya adını kısaltma işlemi
    const shortenedFileName =
        fileName.length > 20 ? `${fileName.substring(0, 20)}...` : fileName;

    return (
        <li style={{ display: 'inline-block', marginRight: '4px' }}>
            <Tooltip content={fileName} relationship="label">
                <Button
                    icon={getFileIcon(fileName)}
                    onClick={onDownload}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        padding: 0,
                        fontSize: 'inherit',
                    }}
                >
                    {shortenedFileName}
                </Button>
            </Tooltip>
        </li>
    );
};